import { render } from "./SquareRoot.vue?vue&type=template&id=53dda8db"
import script from "./SquareRoot.vue?vue&type=script&lang=js"
export * from "./SquareRoot.vue?vue&type=script&lang=js"

import "./SquareRoot.vue?vue&type=style&index=0&id=53dda8db&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__